<template>
  <sa-page-layout :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
    <template slot="toolbar">
      <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovo">
        <b-icon icon="plus"> </b-icon>
        Nuovo
      </b-button>
    </template>
    <template slot="table-filter">
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label class="sa-label-data">Struttura:</label>
            <b-form-select v-model="filtro.codiceStruttura" text-field="denominazione" value-field="codiceStruttura" :options="struttureOptions">
              <template #first>
                <b-form-select-option :value="null"> TUTTE </b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label class="sa-label-data">Nome Consenso:</label>
            <b-form-input v-model="filtro.nomeConsenso"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label class="sa-label-data">Tipologia:</label>
            <b-form-select v-model="filtro.tipologia" :options="tipologiaOptions"> </b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
            <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
            <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </template>
    <template slot="table-body">
      <consensi-list-component ref="cmpConsensiListComponent" @afterLoadData="onAfterLoadData"></consensi-list-component>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ConsensiListComponent from "../components/ConsensiListComponent.vue";

export default {
  components: { SaPageLayout, ConsensiListComponent },
  data() {
    return {
      showModalLoading: false,
      btnNewVisible: true,
      btnRefreshVisible: true,
      struttureOptions: [],
      filtro: {
        nomeConsenso: null,
        codiceStruttura: null,
        sezione: null,
        tipologia: null,
      },
      tipologiaOptions: [
        { text: "TUTTI", value: null },
        { text: "FACOLTATIVO", value: "FACOLTATIVO" },
        { text: "OBBLIGATORIO", value: "OBBLIGATORIO" },
      ],

      pathResource: null,
      linkedit: "pua",
    };
  },
  mounted() {
    let me = this;
    this.loadStrutture();
    me.loadData();
    let sessionStorage = window.sessionStorage;
    if (sessionStorage["filtroConsensi"]) {
      this.filtro = JSON.parse(sessionStorage["filtroConsensi"]);
    }
  },
  methods: {
    loadData() {
      let me = this;
      me.showModalLoading = true;
      me.$refs.cmpConsensiListComponent.init(me.filtro);
    },
    onRefresh() {
      let me = this;
      me.loadData();
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    onClickNuovo() {
      this.$refs.cmpConsensiListComponent.openModalNuovoCosenso();
    },
    onReset() {
      let sessionStorage = window.sessionStorage;
      this.filtro = {
        nomeConsenso: null,
        codiceStruttura: null,
        sezione: null,
        tipologia: null,
      };
      sessionStorage["filtroConsensi"] = JSON.stringify(this.filtro);
      this.loadData();
    },
    onSubmit() {
      let sessionStorage = window.sessionStorage;

      sessionStorage["filtroConsensi"] = JSON.stringify(this.filtro);
      this.loadData();
    },

    loadStrutture() {
      UtilityMixin.methods.loadDataResources("/strutture", {}, this.loadStruttureSuccess, this.loadStruttureError);
    },
    loadStruttureSuccess(response) {
      this.struttureOptions = response.data.data;
    },
    loadStruttureError(error) {
      console.log(error);
    },
  },
};
</script>

<style></style>
